(function () {
  'use strict';


  /* =========================================================
     FEATURED CATEGORIES
     ========================================================= */

  function initFeaturedCategories(section) {

    if (!section) return;


    const slider =
      section.querySelector(
        '[data-vs-fc-slider]'
      );

    const previousButton =
      section.querySelector(
        '.vs-fc-prev'
      );

    const nextButton =
      section.querySelector(
        '.vs-fc-next'
      );


    if (!slider) return;


    /* =========================================================
       SLIDER SCROLL AMOUNT
       ========================================================= */

    function getScrollAmount() {

      const card =
        slider.querySelector(
          '.vs-fc-card'
        );


      if (!card) {
        return 300;
      }


      const cardWidth =
        card.getBoundingClientRect().width;


      const styles =
        window.getComputedStyle(
          slider
        );


      const gap =
        parseFloat(
          styles.columnGap ||
          styles.gap ||
          0
        );


      return cardWidth + gap;

    }


    /* =========================================================
       NEXT
       ========================================================= */

    function scrollNext() {

      slider.scrollBy({

        left: getScrollAmount(),

        behavior: 'smooth'

      });

    }


    /* =========================================================
       PREVIOUS
       ========================================================= */

    function scrollPrevious() {

      slider.scrollBy({

        left: -getScrollAmount(),

        behavior: 'smooth'

      });

    }


    /* =========================================================
       ARROW BUTTONS
       ========================================================= */

    if (nextButton) {

      nextButton.addEventListener(
        'click',
        scrollNext
      );

    }


    if (previousButton) {

      previousButton.addEventListener(
        'click',
        scrollPrevious
      );

    }


    /* =========================================================
       UPDATE ARROW STATE
       ========================================================= */

    function updateArrowState() {

      if (
        !previousButton &&
        !nextButton
      ) {
        return;
      }


      const maxScroll =
        slider.scrollWidth -
        slider.clientWidth;


      const currentScroll =
        slider.scrollLeft;


      if (previousButton) {

        previousButton.disabled =
          currentScroll <= 2;

      }


      if (nextButton) {

        nextButton.disabled =
          currentScroll >=
          maxScroll - 2;

      }


      if (previousButton) {

        previousButton.style.opacity =
          currentScroll <= 2
            ? '0.45'
            : '1';

      }


      if (nextButton) {

        nextButton.style.opacity =
          currentScroll >=
          maxScroll - 2
            ? '0.45'
            : '1';

      }

    }


    slider.addEventListener(

      'scroll',

      updateArrowState,

      {
        passive: true
      }

    );


    window.addEventListener(

      'resize',

      updateArrowState

    );


    updateArrowState();


    /* =========================================================
       KEYBOARD NAVIGATION
       ========================================================= */

    slider.addEventListener(

      'keydown',

      function (event) {


        if (
          event.key ===
          'ArrowRight'
        ) {

          event.preventDefault();

          scrollNext();

        }


        if (
          event.key ===
          'ArrowLeft'
        ) {

          event.preventDefault();

          scrollPrevious();

        }


      }

    );


    /* =========================================================
       MOUSE WHEEL HORIZONTAL MOVEMENT
       ========================================================= */

    slider.addEventListener(

      'wheel',

      function (event) {


        if (
          Math.abs(event.deltaY) >
          Math.abs(event.deltaX)
        ) {


          if (
            slider.scrollWidth >
            slider.clientWidth
          ) {

            slider.scrollLeft +=
              event.deltaY;

          }

        }


      },

      {
        passive: true
      }

    );


    /* =========================================================
       PREMIUM IMAGE SPLIT ANIMATION
       ========================================================= */

    initVSFeaturedCategorySplit(
      section
    );

  }



  /* =========================================================
     PREMIUM 4-PIECE IMAGE SPLIT
     
     Hover:
     FAST SPLIT
     ↓
     1 SECOND HOLD
     ↓
     SMOOTH EXACT RETURN
     ========================================================= */

  function initVSFeaturedCategorySplit(section) {
    if (!section) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) return;
    const hoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)');
    const imageWraps = section.querySelectorAll('.vs-fc-image-wrap');

    imageWraps.forEach(function(imageWrap) {
      if (imageWrap.dataset.vsSplitReady === 'true') return;
      const originalImage = imageWrap.querySelector('.vs-fc-image');
      if (!originalImage) return;
      imageWrap.dataset.vsSplitReady = 'true';
      const splitLayer = document.createElement('div');
      splitLayer.className = 'vs-fc-split-layer';
      for (let i=0;i<4;i++) {
        const piece=originalImage.cloneNode(true);
        piece.className='vs-fc-split-piece';
        piece.setAttribute('aria-hidden','true');
        piece.setAttribute('tabindex','-1');
        piece.removeAttribute('loading');
        splitLayer.appendChild(piece);
      }
      imageWrap.appendChild(splitLayer);
      let animationTimer=null;
      let navigationTimer=null;
      function playSplitAnimation(){
        if(imageWrap.classList.contains('vs-fc-split-active')) return;
        clearTimeout(animationTimer);
        imageWrap.classList.remove('vs-fc-split-active');
        void imageWrap.offsetWidth;
        imageWrap.classList.add('vs-fc-split-active');
        animationTimer=setTimeout(function(){imageWrap.classList.remove('vs-fc-split-active');},1800);
      }
      if(hoverDevice.matches){imageWrap.addEventListener('mouseenter',playSplitAnimation);}
      imageWrap.addEventListener('pointerup',function(event){
        if(event.pointerType==='mouse') return;
        playSplitAnimation();
        const card=imageWrap.closest('.vs-fc-card');
        if(!card) return;
        const href=card.getAttribute('href');
        if(!href || href==='#') return;
        event.preventDefault();
        clearTimeout(navigationTimer);
        navigationTimer=setTimeout(function(){window.location.href=href;},1800);
      });
    });
  }


  /* =========================================================
     INITIALIZE ALL FEATURED CATEGORY SECTIONS
     ========================================================= */

  function initAllFeaturedCategories() {


    const sections =
      document.querySelectorAll(
        '.vs-fc-section'
      );


    sections.forEach(

      function (section) {

        initFeaturedCategories(
          section
        );

      }

    );

  }



  /* =========================================================
     PAGE LOAD
     ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {


    document.addEventListener(

      'DOMContentLoaded',

      initAllFeaturedCategories

    );


  } else {


    initAllFeaturedCategories();

  }



  /* =========================================================
     SHOPIFY THEME EDITOR SUPPORT
     ========================================================= */

  document.addEventListener(

    'shopify:section:load',

    function (event) {


      const section =
        event.target.querySelector(
          '.vs-fc-section'
        );


      if (section) {

        initFeaturedCategories(
          section
        );

      }


    }

  );


})();